import './EditProfilePage.css'


function EditProfilePage() {
  return (
    <div>
      <div className="edit-container">
        <h1>Edit Profile zone</h1>
        <h4>Add new image</h4>
      </div>
    </div>
  );
}

export default EditProfilePage;
